import { Directory } from '.';

export interface InitiatedUploadData {
  fileName: string;
  attachedId: number;
}

export interface InitiatedUpload {
  bucketKeyEnabled: null;
  bucketName: string;
  key: string;
  uploadId: string;
  abortDate: null;
  abortRuleId: null;
  requesterCharged: boolean;
  ssealgorithm: string;
  ssecustomerAlgorithm: null;
  ssecustomerKeyMd5: null;
  serverSideEncryption: string;
}

export interface Upload {
  bucketKeyEnabled: null;
  partNumber: number;
  requesterCharged: boolean;
  etag: string;
  partETag: {
    partNumber: number;
    etag: string;
  };
  ssecustomerAlgorithm: null;
  ssecustomerKeyMd5: null;
  serverSideEncryption: string;
  ssealgorithm: string;
}

export interface CompleteUploadData {
  uploadId: InitiatedUpload['uploadId'];
  fileName: InitiatedUploadData['fileName'];
  attachedId: Directory['id'];
  documentTags: {
    id: number;
  }[];
  fileSize: number;
  partETags: Upload['partETag'][];
}

export enum FileStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Paused = 'Paused',
  Resumed = 'Resumed',
  Cancelled = 'Cancelled',
  /**
   * Terminal status for a file whose upload could not be trusted: a rejected
   * chunk, a rejected completeUpload, a failed initiate, or a transport failure
   * (see src/hooks/upload-files.ts).
   *
   * ADDITIVE by design. The value is the same 'Failed' string TICKET-003 shipped
   * as a cast, and nothing in the repo switches exhaustively over FileStatus, so
   * every existing comparison keeps its meaning: `=== Completed` is false (never
   * counted as done), `includes(InProgress, Resumed)` is false (no pause
   * control, never re-entered by the upload queue), `=== Paused` is false (no
   * resume control). A failed row therefore reads as "not running and not
   * done" everywhere it is rendered today.
   */
  Failed = 'Failed',
}

export type ModuleName = 'Document' | 'Task';
